/**
 * @flow
 */

import Orchestrator from './orchestrator';
import {
  addClickHandler,
  triggerOpen,
  registerWidget,
  replaceEmbed,
  reloadWidget
} from './plugins';

export default function bootstrap() {
  let orchestrator: Orchestrator;

  if (!window.$u || !window.$u.orchestrator) {
    orchestrator = new Orchestrator();
    window.$u = {
      orchestrator,
      open: orchestrator.showCheckout,
      reload: reloadWidget(orchestrator)
    };

    // plugins that meant to be executed once
    addClickHandler(orchestrator);
    triggerOpen(orchestrator);
    replaceEmbed(orchestrator);
  }

  else {
    orchestrator = window.$u.orchestrator;
  }

  // plugins that can be executed multiple times
  registerWidget(orchestrator);
}

bootstrap();



// WEBPACK FOOTER //
// ./src/bootstrap/index.js